import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

export default function CommitmentPageForDoerAbsent({ user }) {
  const [searchParams] = useSearchParams();

  const weekStart = searchParams.get("weekStart");
  const weekEnd = searchParams.get("weekEnd");

  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const [score, setScore] = useState("");
  const [remark, setRemark] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_NAV_API}/em/commitment-data`,
        {
          params: {
            email: user.email,
            weekStart,
            weekEnd
          }
        }
      );

      setData(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>📌 Commitment Page</h2>

      <p>
        Week: <b>{weekStart}</b> → <b>{weekEnd}</b>
      </p>

      {/* ✅ TABLE */}
      <table border="1" cellPadding="8" style={{ width: "100%", fontSize: 14 }}>
        <thead style={{ background: "#f1f5f9" }}>
          <tr>
            <th>Process</th>
            <th>Total Task</th>
            <th>Done</th>
            <th>Not Done</th>
            <th>On Time</th>
            <th>Delay</th>
            <th>Total Score</th>
            <th>Penalty</th>
            <th>Final Score</th>
            <th>PC Remark</th>
            <th>Commitment</th>
          </tr>
        </thead>

        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              <td>{row.processName}</td>
              <td>{row.totalTask}</td>
              <td>{row.done}</td>
              <td>{row.notDone}</td>
              <td>{row.onTime}</td>
              <td>{row.delay}</td>
              <td>{row.totalScore}</td>
              <td>{row.penalty}</td>
              <td style={{ fontWeight: "bold" }}>{row.finalScore}</td>
              <td>{row.pcRemark || "-"}</td>

              <td>
                {row.commitmentScore ? (
                  <span style={{ color: "green", fontWeight: "bold" }}>
                    ✅ Submitted
                  </span>
                ) : (
                  <button
                    style={{
                      background: "#dc2626",
                      color: "#fff",
                      padding: "6px 10px",
                      border: "none",
                      borderRadius: 5,
                      cursor: "pointer"
                    }}
                    onClick={() => openModal(row)}
                  >
                    Give Commitment
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ✅ MODAL */}
      {selectedRow && (
        <div style={modalOverlay}>
          <div style={modalBox}>
            <h3>Give Commitment</h3>

            <p>
              <b>{selectedRow.processName}</b>
            </p>

            <input
              type="number"
              placeholder="Commitment Score (-20 to -100)"
              value={score}
              onChange={(e) => setScore(e.target.value)}
              style={inputStyle}
            />

            <textarea
              placeholder="Enter Remark"
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              style={inputStyle}
            />

            <div style={{ marginTop: 10 }}>
              <button onClick={submitCommit} style={btnPrimary}>
                Submit
              </button>

              <button onClick={closeModal} style={btnSecondary}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  // ---------------- HANDLERS ----------------

  function openModal(row) {
    setSelectedRow(row);
    setScore("");
    setRemark("");
  }

  function closeModal() {
    setSelectedRow(null);
  }

async function submitCommit() {
  if (!score || !remark) {
    alert("Fill all fields");
    return;
  }

  // ✅ only basic numeric check (no range restriction)
  if (isNaN(score)) {
    alert("Score must be a number");
    return;
  }

  try {
    await axios.post(
      `${process.env.REACT_APP_NAV_API}/em/saveCommitment`,
      {
        weekStart,
        weekEnd,
        doerEmail: user.email,
        doerName: user.name,
        department: selectedRow.department,
        processName: selectedRow.processName,
        commitmentScore: score,
        commitmentRemark: remark,
        createdBy: user.email
      }
    );

    alert("Saved ✅");
    closeModal();
    fetchData();

  } catch (err) {
    console.error(err);
    alert("Error ❌");
  }
}
}

// ---------------- STYLES ----------------

const modalOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

const modalBox = {
  background: "#fff",
  padding: 20,
  borderRadius: 10,
  width: 350
};

const inputStyle = {
  width: "100%",
  marginTop: 10,
  padding: 8
};

const btnPrimary = {
  background: "#2563eb",
  color: "#fff",
  padding: "6px 12px",
  border: "none",
  marginRight: 10,
  borderRadius: 5
};

const btnSecondary = {
  background: "#94a3b8",
  color: "#fff",
  padding: "6px 12px",
  border: "none",
  borderRadius: 5
};